import { render, staticRenderFns } from "./PaoList.vue?vue&type=template&id=845af6d4&scoped=true"
import script from "./PaoList.vue?vue&type=script&lang=js"
export * from "./PaoList.vue?vue&type=script&lang=js"
import style0 from "./PaoList.vue?vue&type=style&index=0&id=845af6d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "845af6d4",
  null
  
)

export default component.exports